<template>
    <div>
        <h1>{{msg}}</h1>
        <div class="wrapper">
            <div class="section section--match">
                <h2>Match</h2>
                <Match v-on:matchUpdated="updateMatch"></Match>    
            </div>
            <div class="section section--teams">
                <h2>Teams</h2>
                <Team v-on:teamUpdated="updateTeams"></Team>
            </div>
            <div class="section section--players">
                <h2>Players</h2>
                <Player v-on:playerUpdated="updatePlayers"></Player>
            </div>
        </div>

        <Meta
        	:match="config.match"
			:teams="config.teams"
			:players="config.players">
        </Meta>
    </div>
</template>

<script>
import Match from '@/components/Match';
import Team from '@/components/Team';
import Player from '@/components/Player';
import Meta from '@/components/Meta';

export default {
  name: 'home',
  data () {
    return {
      msg: 'FFA Brightcove Metadata Helper',
      config: {
            teams: {},
            players: {},
            match: '',
        }
    }
  },
  created () {
       
  },
  methods: {
    updateTeams: function(data) {
        var self = this;
        self.config.teams = data;
    },
    updatePlayers: function(data) {
        var self = this;
        self.config.players = data;
    },
    updateMatch: function(data) {
        var self = this;
        self.config.match = data;
    },
  },
  mounted: function() {
  },
  components: {
    Match,
    Team,
    Player,
    Meta
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import url('https://fonts.googleapis.com/css?family=Open+Sans');

	* {
	    box-sizing: border-box;
	}

	::selection {
		background-color: #558564;
		color:#fff;
	}

	body {
	    font-family: 'open Sans', sans-serif;
	    overflow-x: hidden;
	}
	.wrapper {
	    display: flex;
	    flex-direction: row;
	    flex-wrap: wrap;
	    max-width: 1200px;
	    margin: 0 auto;

	    div {
	        display: flex;
	        flex-direction: column;
	        flex-grow: 1;
	        flex-shrink: 1;
	        flex-basis: auto;
	    }
	}

	.section {
	    text-align: left;
	    float: left;
	    background-color: #fafafa;
	    border-radius: 6px;
	    padding: 20px;
	    margin-bottom: 20px;
	    flex-direction: column;
	    min-width:280px;
	    margin: 10px;

	    &--match {
	    	flex-grow: 2 !important;
	    	flex-basis: 100% !important;
	    }
	}

	input {
		display: none;
	}


	h2 {
	    display: block;
	    width: 100%;
	    color: #558564;
	    margin-top: 0;
	    font-size: 24px;
	    position: relative;
	    margin-bottom: 1em;

	    &::after {
			content: '';
			display: block;
			height: 3px;
			width: 60px;
			background-color: currentColor;
			position: absolute;
			top:100%;

	    }
	}

	select[multiple] option:checked {
	  background: #49D49D linear-gradient(0deg, #49D49D 0%, #49D49D 100%);
	  color: #fff;
	}

	select[multiple]:focus option:checked {
	  background: #49D49D linear-gradient(0deg, #49D49D 0%, #49D49D 100%);
	  color: #fff;
	}

	select {
	    width: 100%;
	    margin-bottom: 10px;
	    font-size: 20px;
	    line-height: 1.3;

	    &:focus {
	    	outline: none;
	    }

	    option:hover {
	    	background:#dadada !important;
	    }
	}

	[multiple] {
	    height: 10em;
	    margin-bottom: 30px;
	}

	input {
	    font-size: 24px;
	    padding: 15px;
	    color: #000;
	    max-width: 100%;
	    width: 100%;
	    margin-top: auto;
	    align-self: flex-end;
	}

</style>



// WEBPACK FOOTER //
// Home.vue?47b1a36c